var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Chart from "react-apexcharts";
import CardChart, { getWeekLegend } from "./Charts";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
export var VotesPerDay = function (_a) {
    var data = _a.data, width = _a.width, height = _a.height, endDate = _a.endDate;
    var t = useTranslation().t;
    if (!data) {
        return _jsx(CircularProgress, {});
    }
    var state = {
        options: {
            chart: {
                id: "barchart-votes",
            },
            xaxis: {
                categories: getWeekLegend(endDate),
            },
        },
        series: [
            {
                name: "series-1",
                data: data.map(function (item) { return item.day_count; }),
            },
        ],
    };
    return (_jsx(CardChart, __assign({ title: t("dashboard.voteByDay") }, { children: _jsx(Chart, { options: state.options, series: state.series, type: "bar", width: width, height: height }) })));
};
